import { render, staticRenderFns } from "./MessengerColletion.vue?vue&type=template&id=4bb63dfe&scoped=true"
import script from "./MessengerColletion.vue?vue&type=script&lang=js"
export * from "./MessengerColletion.vue?vue&type=script&lang=js"
import style0 from "./MessengerColletion.vue?vue&type=style&index=0&id=4bb63dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb63dfe",
  null
  
)

export default component.exports